// Matriz de recursos por tipo de número (F3). Usada por `GET /v1/numeros`, pelo guard das rotas e pela documentação.
import type { TipoNumero } from "./enums";

export const RECURSOS = [
  "envio.texto",
  "envio.midia",
  "envio.localizacao",
  "envio.contato",
  "envio.figurinha",
  "envio.enquete",
  "envio.template",
  "envio.interativo",
  "envio.citacao",
  "envio.mencao",
  "envio.previaLink",
  "operacao.reacao",
  "operacao.lida",
  "operacao.digitando",
  "operacao.editar",
  "operacao.apagar",
  "contatos.verificar",
  "contatos.info",
  "contatos.bloquear",
  "numero.agenda",
  "numero.perfil",
  "numero.privacidade",
  "numero.configuracoes",
  "conversa.organizar",
  "historico.sincronizar",
  "chamada.rejeitar",
  "grupos",
  "numero.status",
  "etiquetas",
  "comunidades",
  "canais",
] as const;
export type Recurso = (typeof RECURSOS)[number];

const COMUNS: Recurso[] = [
  "envio.texto",
  "envio.midia",
  "envio.localizacao",
  "envio.contato",
  "envio.figurinha",
  "envio.citacao",
  "envio.previaLink",
  "operacao.reacao",
  "operacao.lida",
  "operacao.digitando",
];

export const RECURSOS_POR_TIPO: Record<TipoNumero, readonly Recurso[]> = {
  NAO_OFICIAL: [
    ...COMUNS,
    "envio.enquete",
    "envio.mencao",
    "operacao.editar",
    "operacao.apagar",
    "contatos.verificar",
    "contatos.info",
    "contatos.bloquear",
    "numero.agenda",
    "numero.perfil",
    "numero.privacidade",
    "numero.configuracoes",
    "conversa.organizar",
    "historico.sincronizar",
    "chamada.rejeitar",
    "grupos",
    "numero.status",
    "etiquetas",
    "comunidades",
    "canais",
  ],
  OFICIAL: [...COMUNS, "envio.template", "envio.interativo", "numero.perfil"],
};

export function temRecurso(tipo: TipoNumero, recurso: Recurso): boolean {
  return RECURSOS_POR_TIPO[tipo].includes(recurso);
}
